import { useCallback, useEffect, useState } from 'react';

export const OTP_RESEND_COOLDOWN_SECONDS = 60;

export default function useOtpResendCooldown(initialSeconds = 0) {
    const [secondsRemaining, setSecondsRemaining] = useState(() => (
        Math.max(0, Math.ceil(Number(initialSeconds) || 0))
    ));

    useEffect(() => {
        if (secondsRemaining <= 0 || typeof window === 'undefined') return undefined;
        const timer = window.setInterval(() => {
            setSecondsRemaining((current) => Math.max(0, current - 1));
        }, 1000);
        return () => window.clearInterval(timer);
    }, [secondsRemaining]);

    const start = useCallback((seconds = OTP_RESEND_COOLDOWN_SECONDS) => {
        const nextSeconds = Math.max(0, Math.ceil(Number(seconds) || OTP_RESEND_COOLDOWN_SECONDS));
        setSecondsRemaining(nextSeconds);
    }, []);

    const reset = useCallback(() => {
        setSecondsRemaining(0);
    }, []);

    return {
        secondsRemaining,
        isCoolingDown: secondsRemaining > 0,
        start,
        reset,
    };
}
